module.exports = __webpack_public_path__ + "img/icon-smiley-indifferent.a82bcb3.svg";